import { ShapeUtils } from "./ShapeUtils.js";

export const makeFix = function() {
    const THREE = window.THREE;

    if (THREE.REVISION === '71') {
        THREE.Shape.Utils.triangulateShape = ShapeUtils.triangulateShape;
    }
}
